import { render, staticRenderFns } from "./performanceSetting.vue?vue&type=template&id=a1e869ae&scoped=true&"
import script from "./performanceSetting.vue?vue&type=script&lang=js&"
export * from "./performanceSetting.vue?vue&type=script&lang=js&"
import style0 from "./performanceSetting.vue?vue&type=style&index=0&id=a1e869ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e869ae",
  null
  
)

component.options.__file = "performanceSetting.vue"
export default component.exports